<template>
  <div class="modal-container clearfix">
    <vxe-form
        style="margin-top: 50px"
        ref="xForm"
        class="my-form2"
        title-align="right"
        :data="formData"
        :rules="formRules">
      <vxe-form-item title="上报企业" field="reportCompany" span="24">
        <template>
          <Select v-model="formData.reportCompany" style="width: 260px;">
            <Option v-for="(item,index) in report_company" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="modal-footer add-btn-box">
      <Button @click="close" style="width: 100px">取 消</Button>
      <Button status="primary" style="width: 100px" @click="commit">确 定</Button>
    </div>
  </div>
</template>
<script>

  import $api from "@/apiProvider";

  export default {
    data() {
      return {
        formData: {
          reportCompany: 1
        },
        report_company: [],
        formRules: {
          reportCompany: [{required: true, message: "请选择上报企业"}],
        }
      }
    },
    methods: {
      async queryConfigList() {
        let res = await $api.reportData.get('queryConfigList');
        if (res.status === 1) {
          let data = res.data;
          data.map(i => {
            this.report_company.push({
              label: i.companyName,
              value: i.reportCompany,
            })
          })
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async validEvent() {
        let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
        return errMap ? false : true;
      },
      async commit() {
        let sts = await this.validEvent();
        if (!sts) {
          return;
        }
        this.$emit('report', this.formData.reportCompany);
      },
      close() {
        this.formData = {
          reportCompany: null
        };
        this.$emit('close');
      }
    }
  }
</script>
<style scoped>
  .modal-footer {
    padding: 10px 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 96%;
    position: absolute;
    bottom: 0;
  }
</style>